import { Component } from "react";
import { browserHistory } from "react-router";

import _ from "underscore";
import states from "admin/routes.states";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";

// Helper components
import DepositTab from "./Accounting.Deposit.Tab";
import InvoiceTab from "./Accounting.Invoice.Tab";
import PropTypes from "prop-types";
import { accountingConnector } from "../../../services/accounting/connector";
import { compose } from "redux";

class AccountingMatchingComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      machingValue: "",
      tabValue: props.initialSelectedIndex,
    };
  }

  componentDidMount() {
    this.props.getUnmatchedInvoiceData();
  }

  redirectToLocation = (tab) => {
    browserHistory.push(states[tab].url);
  };

  manualMatchDeposit = (depositId, paymentId) => {
    this.props.matchDepositManually(
      depositId,
      paymentId,
      this.props.accounting.depositPayments,
    );
    this.props.attachIntervals(5);
  };

  manualMatchInvoice = (invoice, paymentId) => {
    this.props.matchInvoiceManually(
      invoice,
      paymentId,
      this.props.accounting.invoicePayments,
    );
    this.props.attachIntervals(5);
  };

  changeTab = (event, newValue) => {
    this.setState({ tabValue: newValue });
    if (newValue === 0) this.redirectToLocation("matchPaymentsDeposits");
    if (newValue === 1) this.redirectToLocation("matchPaymentsInvoices");
  };

  render = () => {
    //Deposit payments and deposit orders
    var notMatchedDepositPayments = _.filter(
      this.props.accounting.depositPayments.data,
      (item) => {
        return (
          // eslint-disable-next-line no-prototype-builtins
          this.props.accounting.matchedDeposits.data.hasOwnProperty(item.Id) ==
          false
        );
      },
    );

    var matchedDeposits = _.map(
      this.props.accounting.matchedDeposits.data,
      (value) => {
        return value;
      },
    );

    var notMatchedDeposits = _.filter(this.props.deposits.data, (deposit) => {
      return matchedDeposits.indexOf(deposit.Id) == -1;
    });

    //Invoice payments and invoices
    var invoicePaymentsMatched = _.sortBy(
      this.props.accounting.matchedInvoices.data,
      (invoice) => {
        return new Date(invoice.DateEntered).valueOf();
      },
    ).reverse();

    var invoicePayments = _.sortBy(
      this.props.accounting.invoicePayments.data,
      (invoice) => {
        return new Date(invoice.DateEntered).valueOf();
      },
    ).reverse();

    var notMatchedInvoicePayments = _.filter(invoicePayments, (invoice) => {
      return (
        _.findIndex(invoicePaymentsMatched, (matched) => {
          return matched.Id == invoice.Id;
        }) == -1
      );
    });

    var invoices = _.sortBy(this.props.invoices.data, (invoice) => {
      return new Date(invoice.DueDate).valueOf();
    }).reverse();

    return (
      <div className="accounting-layout body-height">
        <Tabs value={this.state.tabValue} onChange={this.changeTab}>
          <Tab label="Deposits" />
          <Tab label="Invoices" />
        </Tabs>
        {this.state.tabValue === 0 && (
          <DepositTab
            notMatchedDepositPayments={notMatchedDepositPayments}
            notMatchedDeposits={notMatchedDeposits}
            manualMatchDeposit={this.manualMatchDeposit}
          />
        )}
        {this.state.tabValue === 1 && (
          <InvoiceTab
            notMatchedInvoicePayments={notMatchedInvoicePayments}
            invoices={invoices}
            manualMatchInvoice={this.manualMatchInvoice}
          />
        )}
      </div>
    );
  };

  static propTypes = {
    initialSelectedIndex: PropTypes.any,
    invoices: PropTypes.any,
    accounting: PropTypes.any,
    deposits: PropTypes.any,
    getUnmatchedInvoiceData: PropTypes.any,
    matchInvoiceManually: PropTypes.func,
    matchDepositManually: PropTypes.func,
    attachIntervals: PropTypes.func,
  };
}

export default compose(accountingConnector)(AccountingMatchingComponent);
